import React from "react";
import { withNamespaces } from "react-i18next";
import { FaCheckCircle } from "react-icons/lib/fa";
import { ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const WelcomeTerms = props => {
  const { t } = props;

  return (
    <React.Fragment>
      <ModalHeader>{t("welcome-terms-heading")}</ModalHeader>
      <ModalBody>
        <p>{t("welcome-terms-paragraph-one")}</p>
        <p>{t("welcome-terms-paragraph-two")}</p>
        <p>{t("welcome-terms-paragraph-three")}</p>
        <p>{t("welcome-terms-paragraph-four")}</p>
      </ModalBody>
      <ModalFooter>
        <Button color="success" onClick={props.next}>
          <FaCheckCircle className="icon" />
          &nbsp;&nbsp;{t("welcome-accept-terms")}
        </Button>
      </ModalFooter>
    </React.Fragment>
  );
};

export default withNamespaces()(WelcomeTerms);



// WEBPACK FOOTER //
// ./src/WelcomeTerms.jsx